<div class="trigger-wrapper" (click)="open = !open" cdkOverlayOrigin #helpTrigger="cdkOverlayOrigin">
  <span class="trigger-label" i18n>Help</span>
  <button mat-fab class="trigger shadow-none" [class.active]="open">
    <i class="icon far fa-question text-xxxl"></i>
  </button>
</div>

<ng-template
  cdkConnectedOverlay
  (overlayOutsideClick)="onOutsideClick($event)"
  [cdkConnectedOverlayOffsetX]="20"
  [cdkConnectedOverlayPositions]="menuPositions"
  [cdkConnectedOverlayOrigin]="helpTrigger"
  [cdkConnectedOverlayOpen]="open"
>
  <div class="help-menu bg-white shadow2 border rounded overflow-hidden" (click)="open = false">
    <div class="help-menu-header">
      <div class="help-menu-title" i18n>Need help?</div>
      <div class="help-menu-subtitle" i18n>Our support team is here for you.</div>
    </div>
    <ul class="list-group list-group-flush help-actions-menu">
      <li class="list-group-item">
        <a (click)="openChat()">
          <span class="btn btn-sm btn-secondary-primary-reverse">
            <i class="far fa-comments"></i>
          </span>
          <span class="item-text">
            <span class="item-label" i18n>Live Chat</span>
            <span class="item-desc" i18n>Talk to our support team now</span>
          </span>
        </a>
      </li>
      <li class="list-group-item">
        <a href="mailto:support@tokeet.com">
          <span class="btn btn-sm btn-secondary-primary-reverse">
            <i class="far fa-envelope"></i>
          </span>
          <span class="item-text">
            <span class="item-label" i18n>Email Support</span>
            <span class="item-desc">support@tokeet.com</span>
          </span>
        </a>
      </li>
      <ng-container *ngIf="!(isFirstPaid$ | async); else firstPaidActions">
        <li class="list-group-item">
          <a (click)="goToScheduleTraining()">
            <span class="btn btn-sm btn-secondary-primary-reverse">
              <i class="far fa-calendar-alt"></i>
            </span>
            <span class="item-text">
              <span class="item-label" i18n>Schedule Training</span>
              <span class="item-desc" i18n>Book a free one-on-one session</span>
            </span>
          </a>
        </li>
      </ng-container>
      <ng-template #firstPaidActions>
        <li class="list-group-item">
          <a (click)="goToOnboarding()">
            <span class="btn btn-sm btn-secondary-primary-reverse">
              <i class="far fa-calendar-alt"></i>
            </span>
            <span class="item-text">
              <span class="item-label" i18n>Schedule Onboarding</span>
              <span class="item-desc" i18n>Get set up with a success agent</span>
            </span>
          </a>
        </li>
        <li class="list-group-item">
          <a (click)="goToDemo()">
            <span class="btn btn-sm btn-secondary-primary-reverse">
              <i class="fal fa-id-card-alt"></i>
            </span>
            <span class="item-text">
              <span class="item-label" i18n>Schedule Training</span>
              <span class="item-desc" i18n>Book a free one-on-one session</span>
            </span>
          </a>
        </li>
      </ng-template>
      <li class="list-group-item">
        <a (click)="goToHelp()">
          <span class="btn btn-sm btn-secondary-primary-reverse">
            <i class="far fa-book"></i>
          </span>
          <span class="item-text">
            <span class="item-label" i18n>Help Center</span>
            <span class="item-desc" i18n>Guides and how-to articles</span>
          </span>
        </a>
      </li>
      <li class="list-group-item">
        <a (click)="goToCommunity()">
          <span class="btn btn-sm btn-secondary-primary-reverse">
            <i class="far fa-users"></i>
          </span>
          <span class="item-text">
            <span class="item-label" i18n>Community</span>
            <span class="item-desc" i18n>Connect with other hosts</span>
          </span>
        </a>
      </li>
      <li class="list-group-item">
        <a (click)="goToTokeetStatus()">
          <span class="btn btn-sm btn-secondary-primary-reverse">
            <i class="far fa-server"></i>
          </span>
          <span class="item-text">
            <span class="item-label" i18n>System Status</span>
            <span class="item-desc" i18n>Check platform uptime</span>
          </span>
        </a>
      </li>
    </ul>
  </div>
</ng-template>
